import React, { useEffect, useState } from "react";
import {
  Navbar,
  Nav,
  Form,
  FormControl,
  Dropdown,
  InputGroup
} from "react-bootstrap";
import recalllogo from "../assets/images/recalllogo_light.png";
import { useDispatch, useSelector } from "react-redux";
import { Search } from "react-bootstrap-icons";
import { ROUTES } from "../assets/constant";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { globalSearch, logout } from "../redux/authSlice";
import FilterOptions from "./filter-options";
import { SecuritySettingsModal } from "./security-settings-modal";

function CustomNavbar() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showSecurityModal, setShowSecurityModal] = useState(false);
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const handleCloseSecurityModal = () => setShowSecurityModal(false);
  const handleCloseNotificationModal = () => setShowNotificationModal(false);
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState(
    user.globalSearch.search || ""
  );

  const handleValueChange = (e) => {
    e.preventDefault();
    setSearchValue(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (searchValue.trim()) {
        navigate(ROUTES.SEARCH);
        dispatch(globalSearch({
          search: searchValue,
        }));
      }
    }
  };

  const location = useLocation();

  useEffect(() => {
    setShowSearchBar(
      location.pathname === ROUTES.DASHBOARD ||
      location.pathname === ROUTES.SEARCH
    );

    if (location.pathname === ROUTES.DASHBOARD) {
      dispatch(
        globalSearch({
          search: "",
          category: null,
          manufacturer: [],
          recallDate: null,
        })
      );
      setSearchValue("");
    }
  }, [dispatch, location]);

  const handleLogout = () => {
    dispatch(logout());
    navigate(ROUTES.LOGIN);
  };

  const handleSecuritySettings = () => {
    setShowSecurityModal(true);
  };

  const handleNotificationSettings = () => {
    setShowNotificationModal(true);
  };

  return (
    <Navbar expand="lg" className="m-0 shadow custom-nav">
      <Navbar.Brand href="/subscriber">
        <img
          src={recalllogo}
          alt="Recall Logo"
          width="80"
          height="30"
          className="d-inline-block align-top"
        />
      </Navbar.Brand>

      <Navbar.Toggle aria-controls="navbarContent" />

      <Navbar.Collapse id="navbarContent" className="justify-content-between">
        <div className="custom-nav-item mx-auto">
          {showSearchBar && (
            <Form className="d-flex" style={{ width: "100%" }}>
              <InputGroup>
                <InputGroup.Text
                  style={{
                    backgroundColor: "white",
                    border: "none",
                    borderRadius: "5px 0 0 5px"
                  }}>
                  <Search />
                </InputGroup.Text>
                <FormControl
                  type="search"
                  style={{ fontSize: "14px", borderTopRightRadius: "5px", borderBottomRightRadius: "5px" }}
                  placeholder="Search among your recalls"
                  aria-label="Search"
                  value={searchValue}
                  onChange={handleValueChange}
                  onKeyPress={handleKeyPress}
                />

                <FilterOptions hideOnLargeScreens={true} />
              </InputGroup>
            </Form>
          )}
        </div>

        <Nav className="ml-auto d-flex">
          <Dropdown align="end">
            <Dropdown.Toggle
              style={{
                backgroundColor: "transparent",
                border: "none",
                padding: "14px",
                fontSize: "1rem"
              }}
              variant="secondary"
              id="user-dropdown">
              {user.user.fname + " " + user.user.lname}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>
                <Link
                  to={ROUTES.EDIT_PROFILE}
                  style={{
                    textDecoration: "none",
                    color: "black",
                    paddingBottom: "10px",
                    fontSize: "0.9rem"
                  }}
                >
                  <i
                    className="fa fa-user"
                    style={{
                      paddingRight: "5px",
                      fontSize: "0.9rem"
                    }}></i>{" "}
                  Edit Profile
                </Link>
              </Dropdown.Item>
              <Dropdown.Item>
                <Link
                  to={ROUTES.CHANGE_PASSWORD}
                  style={{
                    textDecoration: "none",
                    color: "black",
                    fontSize: "0.9rem"
                  }}
                >
                  <i
                    className="fa fa-key"
                    style={{
                      paddingRight: "5px",
                      fontSize: "0.9rem"
                    }}></i>{" "}
                  Change Password
                </Link>
              </Dropdown.Item>
              <Dropdown.Item
                onClick={handleSecuritySettings}
                style={{
                  color: "black",
                  fontSize: "0.9rem"
                }}
              >
                <i
                  className="fa fa-shield-alt"
                  style={{
                    paddingRight: "5px",
                    fontSize: "0.9rem"
                  }}
                ></i>
                Security Settings
              </Dropdown.Item>
              <Dropdown.Item>
                <Link
                  to={ROUTES.NOTIFICATION_PREFERANCES}
                  style={{
                    textDecoration: "none",
                    color: "black",
                    paddingBottom: "10px",
                    fontSize: "0.9rem",
                    display: "block"  // Add this to make the whole area clickable
                  }}
                >
                  <i
                    className="fa fa-bell"
                    style={{
                      paddingRight: "5px",
                      fontSize: "0.9rem"
                    }}
                  ></i>
                  Notification Preferences  {/* ✅ Text is now INSIDE the Link */}
                </Link>
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item
                onClick={handleLogout}
                style={{ color: "red", fontSize: "0.9rem" }}>
                <i
                  className="fa-solid fa-sign-out"
                  style={{ fontSize: "0.9rem" }}></i>{" "}
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Nav>
      </Navbar.Collapse>
      <SecuritySettingsModal
        showModal={showSecurityModal}
        onClose={handleCloseSecurityModal}
      />
    </Navbar>
  );
}

export default CustomNavbar;
